export default {
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["其他安全设置"])}
}